import { createFileRoute } from '@tanstack/react-router';
import { StudentDashboard } from '@/dashboard/StudentDashboard';
import { SHProfile } from '@/profile/SHProfile';
import { useCurrentUser } from '~/hooks/useCurrentUser';

export const Route = createFileRoute('/_app/_users/members/$memberId/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { memberId } = Route.useParams();
  const { isStudent } = useCurrentUser();

  // A student's dashboard is at this URL
  if (isStudent) {
    return <StudentDashboard />;
  }

  // A SH's Profile is at this URL
  return <SHProfile memberId={memberId} />;
}
